import React from "react";


function About2() {
    return (
        <div>

            <section className="page-header" style={{ backgroundImage: 'url(assets/img/page-banner.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="container">
                    <div className="page-header-info">
                        <h2>About Us</h2>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default About2;
